/**
 * Inking Strokes panel — controls stroke construction parameters
 * (simplification, corner detection, taper) and shows bake status.
 */

import { DEFAULT_INKING_MODE_SETTINGS } from "../../app/inkingDefaults.ts";
import { useStore } from "../../app/store.ts";
import { SectionLabel, SliderRow } from "../shared.tsx";

export function InkingStrokesPanelBody() {
  const im = useStore((s) => s.inkingMode);
  const setTaper = useStore((s) => s.setInkingTaperStrength);
  const setSimplification = useStore((s) => s.setInkingSimplificationTolerance);
  const setCornerAngle = useStore((s) => s.setInkingCornerAngle);

  if (!im) return null;

  return (
    <>
      <SectionLabel>Curve Fitting</SectionLabel>
      <SliderRow
        label="Simplification"
        value={im.simplificationTolerance}
        min={0.1}
        max={10}
        step={0.1}
        displayValue={`${im.simplificationTolerance.toFixed(1)} px`}
        onChange={setSimplification}
        defaultValue={DEFAULT_INKING_MODE_SETTINGS.simplificationTolerance}
      />
      <SliderRow
        label="Corner Angle"
        value={im.cornerAngle}
        min={10}
        max={170}
        step={1}
        displayValue={`${Math.round(im.cornerAngle)}°`}
        onChange={setCornerAngle}
        defaultValue={DEFAULT_INKING_MODE_SETTINGS.cornerAngle}
      />

      <SectionLabel>Styling</SectionLabel>
      <SliderRow
        label="Taper"
        value={im.taperStrength}
        min={0}
        max={1}
        step={0.05}
        displayValue={`${Math.round(im.taperStrength * 100)}%`}
        onChange={setTaper}
        defaultValue={DEFAULT_INKING_MODE_SETTINGS.taperStrength}
      />
    </>
  );
}
